
<button (click)="copy()" class="invisible">
  <ngt-button matIcon="share" shape="square" scale="standard" styling="tertiary" />
</button>
